/**
 * 从 hash 路由的 URL 中移除指定的 query 参数
 * 兼容 payment_state 在 hash 内部（#/path?key=val）和外部（?key=val#/path）两种情况
 */
export function removeHistoryQueries(queryKeys: string[]): void {
  // 处理 hash 内部的 query（Vue Router hash 模式）
  const hash = window.location.hash
  const hashParts = hash.split('?')
  const hashPath = hashParts[0]
  const hashQuery = hashParts[1] || ''

  const hashParams = new URLSearchParams(hashQuery)
  queryKeys.forEach(key => hashParams.delete(key))

  const newHashQuery = hashParams.toString()
  const newHash = `${hashPath}${newHashQuery ? `?${newHashQuery}` : ''}`

  // 处理 hash 外部的 query（Stripe 回调时参数在 # 之前）
  const searchParams = new URLSearchParams(window.location.search)
  queryKeys.forEach(key => searchParams.delete(key))
  const newSearch = searchParams.toString()

  const newUrl = `${window.location.pathname}${newSearch ? `?${newSearch}` : ''}${newHash}`
  window.history.replaceState('', document.title, newUrl)
}
